import script from "./OffersCarousel.vue?vue&type=script&lang=ts&setup=true"
export * from "./OffersCarousel.vue?vue&type=script&lang=ts&setup=true"

import "./OffersCarousel.vue?vue&type=style&index=0&id=96794c40&lang=scss&scoped=true"
import "./OffersCarousel.vue?vue&type=style&index=1&id=96794c40&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-96794c40"]])

export default __exports__